<template>
  <div class="language-settings">
    <DropDownsMenu :open="open" :options="langOptions" :default-value="this.config.language" @change="selectOption">
      <template>
        <img :src="getFlagUrl" />
      </template>
    </DropDownsMenu>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { LANG_SELECTION } from '@/utils/constant';
import DropDownsMenu from '@/components/menus/dropdown-items.vue';
import { isEmpty, filter } from 'lodash';

export default {
  props: {
    open: {
      type: String,
      default: 'down',
    },
  },
  components: {
    DropDownsMenu,
  },
  data: () => {
    return {
      url: '',
    };
  },
  computed: {
    ...mapGetters('general', ['config']),
    langOptions() {
      return filter(LANG_SELECTION.data, (d) => {
        return this.config.languageList.includes(d.id);
      });
    },
    getFlagUrl() {
      const defaultOption = this.langOptions.find((option) => option.id === this.config.language) || null;
      if (!isEmpty(defaultOption)) {
        return require(`@/assets/svg/lang-flags/${defaultOption.id}.svg`);
      }
    },
  },
  methods: {
    ...mapActions('general', ['updateGeneral', 'getArenas']),
    // ...mapActions('notifications', ['getNotifications']),
    selectOption({ id, url }) {
      if (url) {
        this.url = url;
      }
      if (id) {
        // const selectSameLang = this.defaultLang === id;
        let config = { ...this.config, language: id };

        this.updateGeneral({ config });
        this.$i18n.set(id);
        this.getArenas();
        // this.getNotifications({});
        // if (!selectSameLang) {
        //   closeNotificationConnection();
        //   initNotificationConnection();
        // }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.language-settings {
  @include displayFlex;
  @include user-select-none;
  width: 100%;
  height: 100%;

  &__mobile {
    width: 100%;
  }
}
img {
  width: 16px;
  height: 16px;
}
</style>
